<template>
  <div class="registerContainer">
    <div class="grid imgGrid mt-0">
      <img
        class="imgContainer"
        src="@/assets/images/mosquita_create_account.png"
      />
      <p class="nunitoBold subheaderText">{{ $t('k_create_account') }}</p>
    </div>
    <div class="grid mt-10 fbGrid">
      <div class="fbButton registerButton">
        <div class="centeredButtonContent">
          <img class="fbLogo" src="@/assets/images/Facebook_Icon.png" />
          <div
            class="buttonCaption nunitoBold"
            v-on:click="registerSocial('facebook')"
          >
            {{ $t('k_signup_button_fb') }}
          </div>
        </div>
      </div>
    </div>

    <div class="grid mt-6 appleGrid">
      <div class="appleButton registerButton">
        <div class="centeredButtonContent">
          <img class="appleLogo" src="@/assets/images/Apple_icon.png" />
          <div
            class="buttonCaption nunitoBold"
            v-on:click="registerSocial('apple')"
          >
            {{ $t('k_signup_button_apple') }}
          </div>
        </div>
      </div>
    </div>
    <div class="mt-10 grid hrLineGrid">
      <span class="ralewayRegular hrLine">{{
        $t('k_signup_button_mail')
      }}</span>
    </div>
    <form action="#" @submit.prevent="submit">
      <div class="formContainer">
        <div class="formElement">
          <label class="ralewayRegular formInputLabel" for="email">{{
            $t('k_email_type')
          }}</label>
          <ValidationProvider
            name="email"
            rules="email|required|max:48"
            v-slot="{ errors }"
          >
            <input
              class="formInput ralewayRegular"
              type="text"
              name="email"
              v-model="email"
              v-bind:placeholder="$t('k_email_type')"
            />
            <span class="ralewayRegular errorText">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="formElement mt-4">
          <label class="ralewayRegular formInputLabel" for="password">{{
            $t('k_pw_type')
          }}</label>
          <ValidationProvider
            name="password"
            rules="min:6|required|max:20"
            v-slot="{ errors }"
          >
            <input
              class="formInput ralewayRegular"
              type="password"
              name="password"
              v-model="password"
              v-bind:placeholder="$t('k_pw_placeholder')"
            />
            <span class="ralewayRegular errorText">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <p-check
          class="p-svg p-curve p-bigger accept mt-5"
          color="success"
          v-model="accept"
          v-on:change="changedTerms()"
        >
          <!-- svg path -->
          <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
            <path
              d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
              style="stroke: white;fill:white"
            ></path>
          </svg>
          <p class="ralewayRegular checkboxLabel">
            <i18n path="k_terms_accept" tag="p" class="innerCheckboxLabel">
              <a
                class="underlineLink"
                href="https://www.marshmallow-games.com/smarttales/tos.html"
                target="_blank"
                >{{ $t('k_terms_conditions_part') }}</a
              >

              <a
                class="underlineLink"
                href="https://www.iubenda.com/privacy-policy/57618649"
                target="_blank"
              >
                <br v-if="isMobile" />{{ $t('k_privacy_policy_part') }}</a
              >
              <a
                class="underlineLink"
                href="https://www.iubenda.com/privacy-policy/57618649/cookie-policy"
                target="_blank"
                >{{ $t('k_cookie_policy_part') }}</a
              >
            </i18n>
          </p>
        </p-check>
      </div>
      <span class="ralewayRegular errorText" v-if="termsError">{{
        $t('k_terms_not_accepted_terms')
      }}</span>
      <div class="grid mt-10 stButtonGrid">
        <div class="stButton registerButton">
          <div class="stButtonCaption nunitoBold" v-on:click="submit()">
            {{ $t('k_signup_button') }}
          </div>
        </div>
      </div>
      <div class="mt-2">
        <span class="signText ralewayRegular">
          {{ $t('k_already_account1') }} </span
        ><router-link :to="{ path: '/login', query: query }"
          ><span class="signLink ralewayBold">
            {{ $t('k_login_subtitle') }}</span
          ></router-link
        >
      </div>
    </form>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import api from '../plugins/api'
import { isFeatureEnabled } from '../services/parameters'
import { socialLoginRegister } from '../services/socialUtils'
import { ValidationProvider } from 'vee-validate'
import { trackEvent } from '../plugins/analyticsTracker'
import { getRedirectAfterRegisterLogin } from '../services/redirectHelper'

export default {
  components: {
    ValidationProvider
  },
  data() {
    return {
      email: '',
      password: '',
      accept: false,
      error: false,
      errorText: '',
      fbLoginEnabled: false,
      appleLoginEnabled: false,
      tagsSocial: [],
      isMobile: false,
      termsError: false,
      query: null
    }
  },
  async mounted() {
    this.query = this.$route.query
    console.log(this.query)
    window.addEventListener('resize', this.onResize)
    this.isMobile = window.innerWidth < 550
    this.fbLoginEnabled = await isFeatureEnabled('fblogin')
    this.appleLoginEnabled = await isFeatureEnabled('applelogin')
  },
  methods: {
    changedTerms() {
      if (this.accept) trackEvent(this.$constants.WEB_REGISTER_TC)
    },

    onResize() {
      if (window.innerWidth > 550) {
        this.isMobile = false
      } else {
        this.isMobile = true
      }
    },
    registerSocial: async function(providerName) {
      trackEvent(
        null,
        providerName == 'facebook'
          ? this.$constants.WEB_REGISTER_FBLOGIN
          : this.$constants.WEB_REGISTER_APPLELOGIN
      )
      try {
        const token = await socialLoginRegister(providerName, this.$i18n.locale)
        localStorage.setItem('access_token', token)
        this.tagsSocial.push(providerName)
        await this.getUser()
        trackEvent(this.$constants.WEB_AUTH_SIGNUP, { provider: providerName })
        const path = getRedirectAfterRegisterLogin(this.query)
        this.$router.push({
          path: path,
          query: this.query
        })
      } catch (errorFirebase) {
        await this.$store.dispatch('cleanAll')
        console.log(errorFirebase)
        trackEvent(this.$constants.WEB_AUTH_ERROR, { provider: providerName })
        if (
          errorFirebase.code == 'auth/account-exists-with-different-credential'
        ) {
          await this.$store.dispatch('setError', {
            errorKey: 'k_generic_error_title',
            errorSubKey: 'k_register_error_social',
            errorImage: '@/assets/images/mosquita_generic_error.png',
            redirect: '/'
          })
          this.$router.push({
            path: '/error',
            query: this.query
          })
        } else if (errorFirebase.code == 'auth/weak-password') {
          await this.$store.dispatch('setError', {
            errorKey: 'k_generic_error_title',
            errorSubKey: 'k_register_short_password',
            errorImage: '@/assets/images/mosquita_generic_error.png',
            redirect: '/'
          })
          this.$router.push({
            path: '/error',
            query: this.query
          })
        } else if (
          errorFirebase.code != 'auth/cancelled-popup-request' &&
          errorFirebase.code != 'auth/popup-closed-by-user'
        ) {
          await this.$store.dispatch('setError', {
            errorKey: 'k_generic_error_title',
            errorSubKey: 'k_generic_error_subtitle',
            errorImage: '@/assets/images/mosquita_generic_error.png',
            redirect: '/'
          })
          this.$router.push({
            path: '/error',
            query: this.query
          })
        }
      }
    },
    submit: async function() {
      this.termsError = false
      trackEvent(this.$constants.WEB_REGISTER_EMAILLOGIN)
      if (this.accept) {
        try {
          this.email = this.email ? this.email.trim() : this.email
          const firebaseUserRes = await firebase
            .auth()
            .createUserWithEmailAndPassword(this.email, this.password)
          const tokenFirebase = await firebaseUserRes.user.getIdToken()
          const tokenResponse = await api.post(
            '/user/token',
            { token: tokenFirebase },
            { headers: { Authorization: tokenFirebase } }
          )
          const token = tokenResponse.data.token
          localStorage.setItem('access_token', token)
          await this.getUser()
          trackEvent(this.$constants.WEB_AUTH_SIGNUP, { provider: 'email' })
          const path = getRedirectAfterRegisterLogin(this.query)
          this.$router.push({
            path: path,
            query: this.query
          })
        } catch (errorFirebase) {
          await this.$store.dispatch('cleanAll')
          localStorage.removeItem('access_token')
          console.log(errorFirebase)
          trackEvent(this.$constants.WEB_AUTH_ERROR, { provider: 'email' })
          if (errorFirebase.code == 'auth/email-already-in-use') {
            await this.$store.dispatch('setError', {
              errorKey: 'k_generic_error_title',
              errorSubKey: 'k_register_error_email_in_use',
              errorImage: '@/assets/images/mosquita_generic_error.png',
              redirect: '/'
            })
          } else if (errorFirebase.code == 'auth/invalid-email') {
            await this.$store.dispatch('setError', {
              errorKey: 'k_generic_error_title',
              errorSubKey: 'k_register_error_email_not_valid',
              errorImage: '@/assets/images/mosquita_generic_error.png',
              redirect: '/'
            })
          } else {
            await this.$store.dispatch('setError', {
              errorKey: 'k_generic_error_title',
              errorSubKey: 'k_generic_error_subtitle',
              errorImage: '@/assets/images/mosquita_generic_error.png',
              redirect: '/'
            })
          }
          this.$router.push({
            path: '/error',
            query: this.query
          })
        }
      } else {
        this.termsError = true
      }
    },
    getUser: async function() {
      const urlGet = process.env.VUE_APP_BACKEND_URL
      const userResponse = await api.get(urlGet + '/user')
      localStorage.setItem('userInfo', JSON.stringify(userResponse.data.user))
      await this.$store.dispatch(
        'updateUserInfo',
        JSON.parse(JSON.stringify(userResponse.data.user))
      )
      const tagsToAdd = [...this.tagsSocial, process.env.VUE_APP_SIGNUP_TAG]
      await api.post(urlGet + '/user/tags/add', { tags: tagsToAdd })
      trackEvent(
        this.$constants.ST_REGISTER_WEB,
        { user: userResponse.data.user, lang: this.$i18n.locale },
        true
      )
    }
  }
}
</script>
<style lang="scss">
.registerContainer {
  .underlineLink {
    text-decoration: underline;
  }
  .innerCheckboxLabel {
    margin-top: -5px;
    margin-left: 5px;
  }
  .checkboxAccepted {
    background-color: var(--primary);
  }

  .registerButton {
    grid-row: 1;
    grid-column: 2/12;
    padding: 10px 0px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .centeredButtonContent {
    grid-row: 1;
    grid-column: 2/12;
    display: flex;
    align-items: center;
  }

  .fbLogo {
    align-self: center;
    width: 6%;
  }

  .appleLogo {
    align-self: center;
    width: 6%;
    padding-bottom: 0.4em;
  }

  .buttonCaption {
    font-size: 1em;
    flex-grow: 2;
    text-align: left;
    margin-left: 1em;
  }

  .stButtonCaption {
    grid-row: 1;
    grid-column: 1/13;
    font-size: 1em;
  }

  .hrLine {
    display: flex;
    grid-row: 1;
    grid-column: 2/12;
    text-align: center;
    align-items: center;
  }

  .hrLine:before,
  .hrLine:after {
    color: white;
    content: '';
    flex: 1;
    border-bottom: 0.2px solid var(--line2);
    margin: auto 0.25em;
    padding-top: 0.25em;
  }

  .formContainer {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .formElement {
    grid-column: 2/12;
  }

  .formInputLabel {
    display: flex;
    font-size: 1em;
    color: var(--formColor);
  }
  .formInput {
    padding: 10px 15px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 1em;
    color: var(--formColor);
  }

  .checkboxLabel {
    font-size: 0.688em;
    color: var(--formColor);
    text-align: left;
    margin-left: 2em;
  }

  .accept {
    display: flex;
    grid-column: 2/7;
    align-self: center;
  }

  @media screen and (min-width: 620px) {
    .innerCheckboxLabel {
      margin-top: 0px !important;
    }
    .formContainer {
      max-width: 600px;
      margin: auto;
    }

    .fbGrid {
      max-width: 600px;
      margin: auto;
    }

    .appleGrid {
      max-width: 600px;
      margin: auto;
    }

    .hrLineGrid {
      max-width: 600px;
      margin: auto;
    }

    .stButtonGrid {
      max-width: 600px;
      margin: auto;
    }
  }
  /* large tablet and laptop styles */
  @media screen and (min-width: 960px) {
  }
  /* desktop styles */
  @media screen and (min-width: 1200px) {
  }
}
.pretty input {
  width: 10%;
}
.pretty.p-bigger label {
  text-indent: 0.1em;
}
</style>
